import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFire, faThermometerHalf } from "@fortawesome/free-solid-svg-icons";
import "./Products.css";

const Products = () => {
  const products = [
    {
      id: 1,
      name: "High Alumina Firebricks & shapes",
      description:
        "Premium quality firebricks with 42-80%/85% alumina content, designed for extreme temperature applications. These bricks offer exceptional thermal shock resistance and mechanical strength, making them ideal for steel furnaces and high-temperature industrial processes.",
      temperature: "1600°C to 1750°C",
      applications: [
        "Steel Industry",
        "Glass Manufacturing",
        "Cement Kilns",
        "Petrochemical Plants",
      ],
      features: [
        "High thermal shock resistance",
        "Excellent mechanical strength",
        "Low thermal conductivity",
        "Superior corrosion resistance",
      ],
      image: "/images/brick1.JPG",
    },
    {
      id: 2,
      name: "IS-8 & Firebricks",
      description:
        "RKR Quality IS-8 firebricks have high refractory value and are very suitable where high temperatures are involved. These bricks conform to IS-8 specification.",
      temperature: "",
      applications: [
        "Alumina____38%",
        "Silica____50-53%",
        "Ferric Oxide____2-2.5%",
        "Porosity______22-23",
        "P.C.E____32",
        "P.L.C._____1.0% at (1400.) For 2 Hrs.",
        "R.U.L._____ta (1400C.)",
        "B.D._______",
        "C.C.S._____250-300",
        "Size Tol.______#2%",
      ],
      features: [
        "Special shapes in RKR Quality can be supplied to customer's requirements.RKR Quality IS-8 fireclay Mortor is recommended for use with the above bricks.",
      ],
      image: "/images/brick2.JPG",
    },
    {
      id: 3,
      name: "POURING REFRACTORIES",
      description:
        "RKR Quality Pouring Refractories are manufactured from special selected clays. These are made on our special presses toproduce Lamination-Free productsWe have been manufacturing and supplying customers requirements:.",
      temperature: "",
      applications: [],
      features: [
        "1. BOTTAM POURING REFRACTORIES FOR ALLOY  STEELS, SPECIAL STEELS, FORGING INGOTS IN HIGH ALUMINA GRADE.",
        "2. GATING SYSTEMS FOR FOUNDRIES WE MANUFACTURE VARIOUS TYPES OF GATING SYSTEMS FOR FOUNDRIES IN HIGH ALUMINA CONTENT.",
        "3.LADDLE SLEEVES/NOZZLES AND LADDLE BRICKSRE MANUFACTURED IN HIGH ALUMINA GRADES IN VARIOUS SIZES AND FOR BIG & SMALL SIZES OF LADDLES",
        " ALL THESE  ITEMS CAN ALSO BE MANUFACTUREDAS PER CUSTOMERS' DRAWINGS AND REQUIREMENTS.",
      ],
      image: "/images/brick3.JPG",
    },
  ];

  return (
    <div className="products">
      <div className="products-hero">
        <div className="container">
          <h1>Our Firebricks Products</h1>
          <p>
            Premium quality refractory materials for diverse industrial
            applications
          </p>
        </div>
      </div>

      <div className="container">
        <div className="products-intro">
          <h2>Comprehensive Firebricks Solutions</h2>
          <p>
            We manufacture a wide range of firebricks designed to meet the
            specific requirements of various industries. Each product is
            engineered for optimal performance, durability, and thermal
            efficiency using the finest raw materials and advanced manufacturing
            techniques.
          </p>
        </div>

        <div className="products-grid">
          {products.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-image">
                <img src={product.image} alt={product.name} />
                <div className="product-overlay">
                  <FontAwesomeIcon icon={faFire} />
                </div>
              </div>
              <div className="product-content">
                <h3>{product.name}</h3>
                <p className="product-description">{product.description}</p>

                {product.temperature && (
                  <div className="product-specs">
                    <div className="spec-item">
                      <FontAwesomeIcon icon={faThermometerHalf} />
                      <span>
                        <strong>Temperature:</strong> {product.temperature}
                      </span>
                    </div>
                  </div>
                )}
                <div className="product-applications">
                  <h4>Applications:</h4>
                  <ul>
                    {product.applications.map((app, index) => (
                      <li key={index}>{app}</li>
                    ))}
                  </ul>
                </div>

                <div className="product-features">
                  <h4>Key Features:</h4>
                  <ul>
                    {product.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="products-cta">
          <div className="cta-content">
            <h2>Need Custom Firebricks?</h2>
            <p>
              We specialize in manufacturing custom firebricks tailored to your
              specific requirements. Our technical team can develop solutions
              for unique applications and operating conditions.
            </p>
            <div className="cta-buttons">
              <button className="btn btn-primary">Request Quote</button>
              <button className="btn btn-outline">Download Catalog</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
